import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cdb4bd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metadata-input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title contents-title" }, "内容確認", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = { class: "navigation-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_7 = { class: "navigation-button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 資料を送信 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmMetadata = _resolveComponent("ConfirmMetadata")!
  const _component_ConfirmFileList = _resolveComponent("ConfirmFileList")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_ConfirmMetadata, { metadataList: _ctx.metadataList }, null, 8, ["metadataList"]),
      _hoisted_3,
      _createVNode(_component_ConfirmFileList, { fileList: _ctx.uploadFileList }, null, 8, ["fileList"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.prev,
          onKeydown: _withKeys(_withModifiers(_ctx.prev, ["prevent"]), ["space","enter"]),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.send,
          onKeydown: _withKeys(_withModifiers(_ctx.send, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-send',
          disabled: !_ctx.metadataList
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_DssIcon, {
              icon: "arrow-right",
              style: {"font-size":"18px"}
            })
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown", "disabled"])
      ])
    ])
  ], 64))
}